import { XIcon } from '@heroicons/react/solid';
import { Alert } from '@mui/material';
import Modal from '@mui/material/Modal';
import { useEffect } from 'react';
import { useState } from 'react';
import { getList } from '../../api/collections';
import FormElement from '../../components/Form/FormElement';
import Spinner from '../../components/spinner';
import useAddStandard from './useAddStandard';

function EditStandard({ name, open, handleClose, type, id, singleData }) {
    const [standardOptions, setStandardOptions] = useState([]);
    const [formData, setFormData] = useState(singleData)
    const { setDataToServer,error, success, onError, onSuccess } = useAddStandard('/updateStandardAndClass')
    const handleSetFromData = (e) => {
        let value = e.target.value
        let data = {
            ...formData,
            type: type,
            [e.target.name]: value
        }
        setFormData(data)
    }

    const handleSaveFromData = (e) => {
        e.preventDefault()
        setDataToServer.mutate(formData)
    }

    useEffect(() => {
        setFormData(prevState => ({
            ...prevState,
            name: name
        }));
        getList("StandardType")
            .then(res => {
                setStandardOptions(res.data);
            })
    }, [])

    return (
        <>
            <Modal disableEscapeKeyDown open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className=' w-[40%] bg-white center-the-div rounded'>
                    <div className='px-8 divide-y'>
                        <div className=''>
                            <h2 className='heading capitalize'>Edit {type}</h2>
                            <XIcon onClick={handleClose} className='w-6 h-6  absolute top-2 right-2 cursor-pointer' />
                        </div>
                        <form className='py-4 space-y-4' onSubmit={handleSaveFromData}>
                            <FormElement
                                label={type}
                                element={'input'}
                                placeholder={`Enter ${type}`}
                                name={'name'}
                                value={formData['name']}
                                required={true}
                                onChange={handleSetFromData}
                                errorMessage='This Field Cannot Be Empty !'
                            />
                            <FormElement
                                label={"Select Standard Type"}
                                element={'select'}
                                optionValue={standardOptions}
                                value={formData['standard_type_id']}
                                name={'standard_type_id'}
                                required={true}
                                onChange={handleSetFromData}
                                errorMessage='This Field Cannot Be Empty !'
                            />

                            {setDataToServer.isLoading ?
                                <Spinner /> :
                                <div>
                                    <button className='primaryButton w-full'>Save</button>
                                </div>}
                            {error && <Alert onClose={() => onError(false)} className='mb-4 capitalize' severity="error" sx={{ width: '100%' }}>{setDataToServer?.error?.response?.data.message}</Alert>}
                            {success && <Alert onClose={() => onSuccess(false)} className='mb-4' severity="success" sx={{ width: '100%' }}>Updated Succesfully</Alert>}
                        </form>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default EditStandard